export default {
  name: 'PAppHeader',
  props: {
    isSearchPage: { default: false, type: Boolean },
    isHomePage: { default: false, type: Boolean },
  },
}
